import React from "react";
import { CheckoutType, Permission } from "types";
import { IsGranted } from "../../../Common/IsGranted";
import { RadioInput } from "../../../Common/RadioInput";
import { ButtonCodeHeading } from "../ButtonCodeHeading";

interface StepTwoCheckoutTypeSelectorProps {
    checkoutType: CheckoutType;
    onChange: (type: CheckoutType) => void;
}

export const StepTwoCheckoutTypeSelector = ({ checkoutType, onChange }: StepTwoCheckoutTypeSelectorProps) => {
    return (
        <div className="flex h-full flex-row items-start space-x-2 py-8">
            <ButtonCodeHeading number={2}>Choose your checkout type</ButtonCodeHeading>
            <div className="ml-15 flex flex-col space-y-2.5">
                <RadioInput
                    checked={checkoutType === CheckoutType.POPUP}
                    name="checkoutType"
                    value={CheckoutType.POPUP}
                    onChange={(e) => onChange(e.target.value)}
                >
                    Pop up
                </RadioInput>
                <IsGranted permissions={Permission.EMBEDDED_CHECKOUT_VIEW}>
                    <RadioInput
                        checked={checkoutType === CheckoutType.EMBEDDED}
                        name="checkoutType"
                        value={CheckoutType.EMBEDDED}
                        onChange={(e) => onChange(e.target.value)}
                    >
                        Embedded
                    </RadioInput>
                </IsGranted>
                <RadioInput
                    checked={checkoutType === CheckoutType.URL}
                    name="checkoutType"
                    value={CheckoutType.URL}
                    onChange={(e) => onChange(e.target.value)}
                >
                    URL
                </RadioInput>
            </div>
        </div>
    );
};
